import { HisUiService } from './../service/base/his-ui.service';
import { Directive, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { HisNumberValidators } from '../validator/his-number-validators';
import { HisValidatorAndMessage } from '../validator/his-validator-and-message';

@Directive( {
    selector: '[hisNumber]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: HisNumberValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class HisNumberValidatorDirective implements Validator, OnInit {
    private uiService = inject( HisUiService );
    private validator: Validator;

    @Input() decimalPlaces: number;

    ngOnInit() {
        const validator = new HisValidatorAndMessage( 'number', HisNumberValidators.isNumber(), this.uiService );
        validator.messageKey = 'jakarta.faces.convert.DoubleConverter.CONVERSION';
        validator.paramNames = ['input'];
        this.validator = validator;
    }

    validate( control: AbstractControl ): ValidationErrors | null {
        return this.validator.validate( control );
    }
}
